import generateTourBundleAccommodationItems from './generateTourBundleAccommodationItems'
import generateDepartureRoomDisplayPriceBreakdown from './generateDepartureRoomDisplayPriceBreakdown'

export default function generateTourBundleUserCartItems(
  tourItems: Array<App.Checkout.TourV2Item>,
  bundle: App.Tours.Bundle | undefined,
  hotel: App.HotelOffer | undefined,
  offer?: App.Tours.TourV2Offer,
): Array<App.Checkout.AnyItem> | undefined {
  const accommodationItems = generateTourBundleAccommodationItems(tourItems, bundle, hotel)
  if (!accommodationItems) return undefined

  const pricedTourItems = tourItems.map(item => {
    const bundledPrice = item.ltleBundleId ? item.purchasableOption.bundledPrice : undefined
    if (bundledPrice === undefined) return item
    const { totalPrice: total, totalMemberPrice: memberTotal } = generateDepartureRoomDisplayPriceBreakdown(item.occupancy, item.purchasableOption, offer)
    return { ...item, total, memberTotal }
  })
  return [...pricedTourItems, ...accommodationItems]
}
